<template>
    <input
        class="border border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full px-4 py-3"
        :class="{
            'border-red-500 bg-red-100': hasError,
        }"
        type="file"
        @input="handleFileUpload"
        :required="required"
        ref="input"
    >
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, File],
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        },
        handleFileUpload(event) {
            this.$emit('update:modelValue', event.target.files[0]);
        },
    }
}
</script>
